import { Colors } from '../../config/theme';
import Wrapper from './button_styled';

type ButtonProps = {
  text?: string;
  primary?: boolean;
  color?: string;
  bg?: string;
  border?: boolean;
  onClick?: () => void;
  className?: string;
  width?: string;
  style?: any;
  primaryButton?: boolean;
  secondaryButton?: boolean;
  disabledButton?: boolean;
  marginLeft?: string;
  marginRight?: string;
  marginTop?: string;
  marginBottom?: string;
  children?: any;
  disabled?: boolean;
};

function Button({
  text,
  color = Colors.white,
  onClick,
  className,
  bg = Colors.greenMain,
  width,
  children,
  style,
  primaryButton,
  secondaryButton,
  disabledButton,
  marginLeft,
  marginRight,
  marginTop,
  marginBottom,
  disabled,
}: ButtonProps) {
  return (
    <Wrapper
      color={color}
      bg={bg}
      onClick={onClick}
      className={className}
      width={width}
      disabled={disabled}
      style={
        primaryButton
          ? {
              ...style,
              background: Colors.greenMain,
              color: Colors.white,
              marginLeft: marginLeft,
              marginTop: marginTop,
              marginRight: marginRight,
              marginBottom: marginBottom,
            }
          : secondaryButton
            ? {
                ...style,
                background: Colors.greenSecondary,
                color: Colors.greenMain,
                marginLeft: marginLeft,
                marginTop: marginTop,
                marginRight: marginRight,
                marginBottom: marginBottom,
              }
            : disabledButton
              ? {
                  ...style,
                  background: Colors.greyStrong,
                  color: Colors.greySecondary,
                  marginLeft: marginLeft,
                  marginTop: marginTop,
                  marginRight: marginRight,
                  marginBottom: marginBottom,
                }
              : style
      }
    >
      {children}
      {text}
    </Wrapper>
  );
}

export default Button;
